import React from "react";
import { AppstoreOutlined, BarsOutlined } from "@ant-design/icons";

import { useConfig } from "../../../data/useConfig";

const LayoutOptions = () => {
  const { resultsLayoutMode, setResultsLayoutMode } = useConfig();

  return (
    <div>
      <AppstoreOutlined
        style={{ fontSize: "1.5rem", marginRight: "5px" }}
        onClick={() => setResultsLayoutMode("grid")}
        className={`beon-search-layout--icon ${
          resultsLayoutMode === "grid"
            ? "beon-search-layout--icon-selected"
            : ""
        }`}
      />
      <BarsOutlined
        style={{ fontSize: "1.5rem" }}
        onClick={() => setResultsLayoutMode("list")}
        className={`beon-search-layout--icon ${
          resultsLayoutMode === "list"
            ? "beon-search-layout--icon-selected"
            : ""
        }`}
      />
    </div>
  );
};

export default LayoutOptions;
